import {ReactNode} from 'react';

interface PillProps {
  children: ReactNode;
}

export const Pill = ({children}: PillProps) => {
  return (
    <div className="inline-flex rounded-md border border-border-primary bg-bg-secondary px-3 py-1.5 text-paragraph-xs text-text-secondary md:text-paragraph-sm">
      {children}
    </div>
  );
};
